import React from 'react';
import { FileInput } from '../../../../components/FileInput';
import { InputWrapper } from '../../../../styles/EditDeleteStyles';

// save files to s3 bucket
// send api request to get sign put url for s3
// then upload image to s3

export const BannerImageSelect = ({
  handleChange,
  fileName,
  style,
  noLabel,
  altLabel = '',
  error,
}: {
  handleChange: (value: File) => void;
  fileName?: string;
  style?: React.CSSProperties;
  noLabel?: boolean;
  altLabel?: string;
  error?: string;
}) => (
  <InputWrapper style={style}>
    {error && (
      <div
        style={{
          color: 'rgb(186, 33, 33)',
          fontSize: '0.8125rem',
          fontWeight: '600',
          marginLeft: '170px',
          marginBottom: '8px',
          fontFamily:
            'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
        }}
      >
        {error}
      </div>
    )}
    <FileInput
      label={altLabel || (noLabel ? '' : 'Banner Image')}
      field="banner_image"
      fileType="image/jpeg, image/png, image/gif, image/webp, image/avif"
      fileName={fileName}
      isChecked={false} // boolean to show file is in use
      handleChange={handleChange}
    />
  </InputWrapper>
);
